module.exports = __webpack_public_path__ + "170d76a39463a4fcd348486082e91f18.svg";